<template>
    <div class="notification">
       <div class="top">
         <span class="title">{{warningInfo.title}}</span>
         <span style="float:right;cursor:default;" @click="handleClose" ><i class="el-icon-close"> </i></span>
       </div>
       <hr>
       <div class="content">
         <p class="word" v-for="item of warningInfo.text" :key="item">{{item}}</p>
       </div>
       <hr>
       <div class="btn_control">
          <el-button  @click="handleJump" type="primary" class="btn_detial">查看详情</el-button>
       </div>
    </div>
</template>

<script>
export default {
  name: 'warningPopup',
  props: {
    warningInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
        formInputWidth:"120px",
        }
  },
  methods: {
    handleJump () {
      this.$emit('JumpPage')
    },
    handleClose () {
      this.$emit('closeNotice')
    },
  }
}
</script>

<style  scoped>
.notification{
  background-color :white;
  color :black;
  align-items :center;
  padding :10px;
  position: fixed;
  bottom:20px;
  right:40px;
  min-width :350px;
  max-width :500px;
  min-height:200px;
  max-height:500px;
  box-shadow :0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.8);
  z-index:10;
}
.fixed_wrap{
   height:50px;
}
.content{
   margin:10px;
}
.word{
  padding-bottom:5px;
}
.top{
  margin:5px;
  margin-bottom:10px;
}
.title{
  font-size: 17px;
  font-weight: bold;
}

.btn_control{
  position: relative;
 
}
.btn_detial{
  position:fixed; 
  bottom:30px;
  right:45px;
}
</style>